import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import { toggleMessageClose } from '../../store/actions/Message';

const Message = () => {
    const dispatch = useDispatch();

    const show = useSelector((state) => state.message.toggleMessage);
    const message = useSelector((state) => state.message.message);
    const type = useSelector((state) => state.message.type);

    function handleClose(event, reason) { 
        if (reason === 'clickaway') {
            return;
        }

        dispatch(toggleMessageClose());
    }

    return (
        show ? (
            <Snackbar
                open={show}
                autoHideDuration={6000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                style={{ zIndex: 10001 }}
            >
                <Alert onClose={handleClose} severity={type} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        ) : ''
    );
};

export default Message;
